<template>
    <a href="/plan">
        <img class="recommend_plan_update_banner" :src="src" :alt="alt" />
    </a>
</template>

<script>
export default {
    name: "RecommendPlanBanner",
    props: {
        src: {
            type: String,
        },
        alt: {
            type: String,
        },
    },
};
</script>


<style>
.recommend_plan_update_banner {
    width: 100%;
    margin-bottom: 20px;
    filter: drop-shadow(0px 10px 4px rgba(0, 0, 0, 0.3));
}
</style>